
import { Link } from "react-router-dom";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import lmiavector from '../assets/images/Vector-02.png'
import * as Icon from 'lucide-react'

export default function Compnay() {
  const particlesInit = async (main) => {
  
    await loadFull(main);
  };


  return (
    <>
    <div className="relative h-full py-10  ">
  
    <div id="particles-js" className=" bg-primary before:absolute before:w-full before:h-full before:bg-black/40" >
      <Particles
        id="tsparticles"
        init={particlesInit}
        // loaded={particlesLoaded}
        options={{
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push"
              },
              onHover: {
                enable: true,
                mode: "repulse"
              },
              resize: true
            },
            modes: {
              push: {
                quantity: 4
              },
              repulse: {
                distance: 200,
                duration: 1.4
              }
            }
          },
          particles: {
            color: {
              value: "#ffffff"
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1
            },
            collisions: {
              enable: true
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "bounce"
              },
              random: false,
              speed: 1,
              straight: false
            },
            number: {
              density: {
                enable: true,
                area: 800
              },
              value:290
            },
            opacity: {
              value: 0.5
            },
            shape: {
              type: "circle"
            },
            size: {
              value: { min: 1, max: 5 }
            }
          },
          detectRetina: true
        }}
      />
                </div>

               

 <div className="container px-5 md:px-10 m-auto">
      <div className="relative z-20 text-white">
      <div className="container px-2 md:px-20 m-auto">
      <div className="py-16">
  <div className="container m-auto px-0 md:px-6">
    <div className="lg:flex justify-between items-center">
      <div className="w-full lg:w-6/12 text-center md:text-left">
        <h1 className="text-xl md:text-4xl font-bold leading-tight mb-5 capitalize">
          {" "}
          Empowering Careers, Streamlining Hiring: LMIA Solutions for All.{" "}
        </h1>
        <p className="text-xl">
          {" "}
          Whether you're an employer looking to hire foreign workers or a skilled professional
seeking employment opportunities in Canada, LMIA.LTD is your trusted partner every
step of the way.
{" "}
        </p>
        <div className="py-5">
          <Link
            to="/contact-us"
            className="text-white rounded-full py-2 px-5 text-lg font-semibold bg-primary inline-block border border-primary mr-3"
          >
           Contact Us
          </Link>
        
        </div>
      </div>
      <div className="lg:w-5/12 order-2">
        <img
          src={lmiavector}
          style={{
            transform:
              "scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg)"
          }}
          alt=""
          className="rounded"
        />
      </div>
    </div>

     <div className="grid grid-cols-1 md:grid-cols-3  gap-x-0  gap-y-3 md:gap-y-4 md:gap-x-4 4xl:gap-x-10 pt-10 justify-center m-auto 3xl:pt-20 ">
     {/* box start */}
     <div className="flex flex-col items-center p-6 space-y-3 text-center bg-transparent border border-white text-white shadow-md rounded-xl">
        <span className="inline-block p-3 text-white bg-transparent border border-white rounded-full dark:text-white dark:bg-blue-500">
        <Icon.ClipboardPlus />
        </span>
        <h1 className="text-xl font-semibold text-white capitalize dark:text-white">
        Customized LMIA Reports
        </h1>
        <p className="text-white dark:text-gray-300">
        We can help you with customized LMIA reports with information tailored to your
request. We will assess your skill set and provide multiple positions across
Canada that meet your skill set.

        </p>
        <Link
          to="/contact-us"
          className="flex items-center -mx-1 text-sm text-white capitalize transition-colors duration-300 transform dark:text-blue-400 hover:underline hover:text-blue-600"
        >
          <span className="mx-1">Contact Us</span>
          <svg
            className="w-4 h-4 mx-1 rtl:-scale-x-100"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </Link>
      </div>
     {/* box end */}
     {/* box start */}
     <div className="flex flex-col items-center p-6 space-y-3 text-center bg-transparent border border-white text-white shadow-md rounded-xl">
        <span className="inline-block p-3 text-white bg-transparent border border-white rounded-full dark:text-white dark:bg-blue-500">
        <Icon.Lightbulb />
        </span>
        <h1 className="text-xl font-semibold text-white capitalize dark:text-white">
        One Stop Solution
        </h1>
        <p className="text-white dark:text-gray-300">
        Once you have found the right employer, with licensed professionals on board,
we can assist with work permit or PR applications.

        </p>
        <Link
          to="/contact-us"
          className="flex items-center -mx-1 text-sm text-white capitalize transition-colors duration-300 transform dark:text-blue-400 hover:underline hover:text-blue-600"
        >
          <span className="mx-1">Contact Us</span>
          <svg
            className="w-4 h-4 mx-1 rtl:-scale-x-100"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </Link>
      </div>
     {/* box end */}
     {/* box start */}
     <div className="flex flex-col items-center p-6 space-y-3 text-center bg-transparent border border-white text-white shadow-md rounded-xl">
        <span className="inline-block p-3 text-white bg-transparent border border-white rounded-full dark:text-white dark:bg-blue-500">
        <Icon.CalendarSearch />
        </span>
        <h1 className="text-xl font-semibold text-white capitalize dark:text-white">
        LMIA Applications Made Easy
        </h1>
        <p className="text-white dark:text-gray-300">
        Utilize our seasoned expertise in LMIA applications to streamline your hiring
process, eliminating the complexities and uncertainties associated with LMIA
applications.


        </p>
        <Link
          to="/contact-us"
          className="flex items-center -mx-1 text-sm text-white capitalize transition-colors duration-300 transform dark:text-blue-400 hover:underline hover:text-blue-600"
        >
          <span className="mx-1">Contact Us</span>
          <svg
            className="w-4 h-4 mx-1 rtl:-scale-x-100"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </Link>
      </div>
     {/* box end */}
     </div>
  </div>
</div>


</div>

      </div>
      </div>


   {/* my data start  */}

 
   {/* my data end */}
    </div>
    </>
  );
}
